import { Outlet, useLocation } from "react-router-dom";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";

const Layout = () => {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === "/uw-questions";

  return (
    <>
      {!hideHeaderFooter && <Header />}
      <Outlet />
      {!hideHeaderFooter && <Footer />}
    </>
  );
};

export default Layout;
